import * as Yup from 'yup';

const expresionRegularPhoneNumber = /^[0-9]+$/;

export const AddRecurringEventsSchema = Yup.object().shape({
  name: Yup.string().required('Name of event is required'),
  street_address: Yup.string().required('Street address is required'),
  max_applications: Yup.number()
    .typeError('Max amount of applications must be numeric')
    .required('Max amount of applications is required'),
  cancellation_deadline: Yup.date()
    .typeError('Cancellation deadline must be a valid date')
    .required('Cancellation deadline is required'),
  refund_deadline: Yup.date()
    .typeError('Refund deadline must be a valid date')
    .required('Refund deadline is required'),
  application_deadline: Yup.date()
    .typeError('Application deadline must be a valid date')
    .required('Application deadline is required'),
  description: Yup.string().required('Description is required'),
  hour_start_event: Yup.string().required('Event start time is required'),
  hour_vendor_setup_start: Yup.string().required('Vendor setup start time is required'),
  hour_vendor_take_down_start: Yup.string().required('Vendor take down start time is required'),
  hour_vendor_take_down_end: Yup.string().required('Vendor take down end time is required'),
  hour_end_event: Yup.string().required('Event end time is required'),
  hour_refund_deadline: Yup.string().required('Refund deadline time is required'),
  fk_state: Yup.string().required('State is required'),
  fk_city: Yup.string().required('City is required'),
  contact_name: Yup.string().required('Contact name is required'),
  contact_email: Yup.string('Enter your email')
    .trim()
    .email('Enter a valid email')
    .required('Contact email is required'),
  contact_phone_number: Yup.string('Enter your phone number')
    .matches(
      expresionRegularPhoneNumber,
      'Phone Number is invalid, you can only use numbers with no spaces',
    )
    .required('Contact phone number is required'),
});
